import * as types from '../../../../types/masters/stoneAttribute/stoneSize/stoneSizeTypes';
import * as api from '../../../../../api/masters/stoneAttribute/stoneSize/stoneSizeApi';

export const fetchStoneSizes = () => async (dispatch) => {
  dispatch({ type: types.FETCH_STONE_SIZE_REQUEST });
  try {
    const data = await api.fetchStoneSizes();
    dispatch({ type: types.FETCH_STONE_SIZE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: types.FETCH_STONE_SIZE_FAILURE, payload: error.message });
  }
};

export const addStoneSize = (stoneSize) => async (dispatch) => {
  try {
    const res = await api.addStoneSize(stoneSize);
    dispatch({ type: types.ADD_STONE_SIZE_SUCCESS, payload: res });
    dispatch(fetchStoneSizes());
  } catch (error) {
    dispatch({ type: types.STONE_SIZE_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const updateStoneSize = (id, stoneSize) => async (dispatch) => {
  try {
    console.log('Updating stone size with ID:', id, 'Data:', stoneSize);
    const res = await api.updateStoneSize(id, stoneSize);
    console.log('Update response:', res);
    dispatch({ type: types.UPDATE_STONE_SIZE_SUCCESS, payload: res });
    dispatch(fetchStoneSizes());
  } catch (error) {
    console.error('Update error:', error);
    dispatch({ type: types.STONE_SIZE_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const deleteStoneSize = (id) => async (dispatch) => {
  try {
    await api.deleteStoneSize(id);
    dispatch({ type: types.DELETE_STONE_SIZE_SUCCESS, payload: id });
    dispatch(fetchStoneSizes());
  } catch (error) {
    dispatch({ type: types.STONE_SIZE_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const setStoneSizeEdit = (stoneSize) => ({
  type: types.SET_STONE_SIZE_EDIT,
  payload: stoneSize,
});

export const clearStoneSizeEdit = () => ({
  type: types.CLEAR_STONE_SIZE_EDIT,
}); 